import { EmbarkCart } from 'shopify-buy';
import get from 'lodash/get';
import { toShopifyGlobalId } from '../storefront-cart';

interface ruleType {
  property: string;
  match_type?: matchType;
  matches: string;
  skip_if_in_cart: boolean;
  recommend: Array<RecommendationType>;
  do_not_recommend?: Array<RecommendationType>;
}

type matchType = 'startsWith' | 'endsWith' | 'includes';

interface RecommendationType {
  product: string;
  variant: number;
  skip_if_in_cart?: boolean;
  sellingPlanId?: number;
  discountCode?: string;
}

type rulesType = Array<ruleType>;

export const rules: rulesType = [
  {
    property: 'product.id',
    match_type: 'startsWith',
    matches: '7295958286396',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'dog-age',
        variant: 40506648133692,
      },
      {
        product: 'dog-gut-health-test',
        variant: 40252778774588,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'DNB',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-on-call',
        variant: 42322828820540,
        sellingPlanId: 1528561724,
        discountCode: 'SJV63JYR52Y0',
      },
      {
        product: 'multi-supplement-for-dogs',
        variant: 42084945723452,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'DNA',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-on-call',
        variant: 42322828820540,
        sellingPlanId: 1528561724,
        discountCode: 'SJV63JYR52Y0',
      },
      {
        product: 'multi-supplement-for-dogs',
        variant: 42084945723452,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'DNP',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'dog-age',
        variant: 40506648133692,
      },
      {
        product: 'multi-supplement-for-dogs',
        variant: 42084945723452,
      },
      {
        product: 'joint-supplement-for-dogs',
        variant: 42084955226172,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'AB-EM-DA',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-on-call',
        variant: 42322828820540,
        sellingPlanId: 1528561724,
        discountCode: 'SJV63JYR52Y0',
      },
      {
        product: 'dog-gut-maintenance-plus',
        variant: 40586717757500,
      },
      {
        product: 'embark-dog-dna-test-kit',
        variant: 40103683719228,
      },
      {
        product: 'embark-dog-dna-test-kit',
        variant: 40103683784764,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'MET201',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-on-call',
        variant: 42322828820540,
        sellingPlanId: 1528561724,
        discountCode: 'SJV63JYR52Y0',
      },
      {
        product: 'joint-supplement-for-dogs',
        variant: 42084955226172,
      },
    ],
  },
  {
    property: 'product.handle',
    match_type: 'startsWith',
    matches: 'embark-dog-dna-test-shelter-program',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'dog-gut-health-test',
        variant: 40252778774588,
      },
      {
        product: 'dog-age',
        variant: 40506648133692,
      },
    ],
    do_not_recommend: [
      {
        product: 'bid2-pack',
        variant: 40638643634236,
      },
      {
        product: '2-pack-embark-breed-health-kit',
        variant: 32282225344572,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'SUPMUL',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-dog-dna-test-kit',
        variant: 40103683719228,
      },
      {
        product: 'joint-supplement-for-dogs',
        variant: 42084955226172,
      },
      {
        product: 'allergy-supplement-for-dogs',
        variant: 42084958961724,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'SUPJO',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'breed-health-test-and-age-test-bundle',
        variant: 40487381467196,
      },
      {
        product: 'dog-age',
        variant: 40506648133692,
      },
      {
        product: 'multi-supplement-for-dogs',
        variant: 42084945723452,
      },
    ],
  },
  {
    property: 'sku',
    match_type: 'startsWith',
    matches: 'SUPAL',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-dog-dna-test-kit',
        variant: 40103683719228,
      },
      {
        product: 'dog-gut-health-test',
        variant: 40252778774588,
      },
      {
        product: 'joint-supplement-for-dogs',
        variant: 42084955226172,
      },
    ],
  },
  {
    property: 'product.handle',
    match_type: 'startsWith',
    matches: 'embark-dog-dna-test-breeder-program',
    skip_if_in_cart: true,
    recommend: [
      {
        product: 'embark-on-call',
        variant: 42322828820540,
        sellingPlanId: 1528561724,
        discountCode: 'SJV63JYR52Y0',
      },
    ],
    do_not_recommend: [
      {
        product: 'dog-age',
        variant: 40506648133692,
      },
      {
        product: 'multi-supplement-for-dogs',
        variant: 42084945723452,
      },
      {
        product: 'joint-supplement-for-dogs',
        variant: 42084955226172,
      },
    ],
  },
];

const upsellOverrideGlobalKey = '__embark_upsellRules';

declare global {
  interface Window {
    [upsellOverrideGlobalKey]: rulesType;
  }
}

function getRules(): rulesType {
  if (typeof window[upsellOverrideGlobalKey] !== 'undefined') {
    return (window[upsellOverrideGlobalKey] || []) as rulesType;
  }

  return rules;
}

export function isInCart(variantId: string, cart: EmbarkCart): boolean {
  return (
    cart.lines.edges.filter((item) => item.node.merchandise?.id === variantId)
      .length !== 0
  );
}

export function getRecommendations(
  cart: EmbarkCart | null
): Array<RecommendationType> {
  const recommendations: Array<RecommendationType> = [];
  if (!cart) {
    return recommendations;
  }

  const isAlreadyRecommended = (item: RecommendationType): boolean => {
    return (
      recommendations.filter((recommendation) => {
        return recommendation.variant === item.variant;
      }).length > 0
    );
  };

  const isSingleItemInCart = cart.lines.edges.length === 1;

  const excludedProducts: Set<string> = new Set();

  getRules().forEach((rule) => {
    const {
      property,
      match_type,
      matches,
      recommend,
      skip_if_in_cart,
      do_not_recommend,
    } = rule;

    cart.lines.edges.forEach((item) => {
      const itemProp = get(item.node.merchandise, property);

      if (!itemProp) {
        return;
      }

      if (
        itemProp === matches ||
        (typeof match_type !== 'undefined' && itemProp[match_type](matches))
      ) {
        recommend.forEach((rec) => {
          const skipItemIfInCart =
            typeof rec.skip_if_in_cart === 'undefined' || rec.skip_if_in_cart;
          if (
            skip_if_in_cart &&
            skipItemIfInCart &&
            isInCart(toShopifyGlobalId(rec.variant.toString()), cart)
          ) {
            return;
          }

          if (isAlreadyRecommended(rec)) {
            return;
          }

          recommendations.push(rec);
        });

        if ('do_not_recommend' in rule && do_not_recommend) {
          do_not_recommend.forEach((notRec) => {
            if (!isSingleItemInCart) {
              const isRecommendedForAnyItem = recommendations.some(
                (rec) => rec.product === notRec.product
              );

              if (isRecommendedForAnyItem) {
                return;
              }
            }

            const index = recommendations.findIndex(
              (recommendation) => recommendation.product === notRec.product
            );
            if (index !== -1) {
              recommendations.splice(index, 1);
            }
            excludedProducts.add(notRec.product);
          });
        }
      }
    });
  });

  return recommendations.filter((rec) => !excludedProducts.has(rec.product));
}
